export default "__VITE_ASSET__BtAhS8Mc__"